/**
 * @file SplitAtField.tsx
 * @description Сколько пунктов меню слева от логотипа при шапке «по центру»
 * (phase19.16 Р1; SB73 — разделитель «здесь логотип»; `theme.header.splitAt`,
 * `null` — поровну). Счётчик «− N +» с вариантом «Поровну».
 */

import { Minus, Plus } from "lucide-react";

import { Button } from "../../ui/button";
import { Label } from "../../ui/label";

/** Верхняя граница счётчика — как в схеме оформления (`splitAt ≤ 20`). */
const SPLIT_MAX = 20;

interface Props {
  value: number | null;
  onChange: (value: number | null) => void;
}

export function SplitAtField({ value, onChange }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <Label>Пунктов меню слева от логотипа</Label>
      <div className="flex flex-wrap items-center gap-2">
        <Button
          variant="outline"
          size="icon"
          aria-label="Меньше пунктов слева"
          disabled={value === 0}
          onClick={() => onChange(value === null ? 2 : Math.max(0, value - 1))}
        >
          <Minus className="size-4" />
        </Button>
        <span className="type-body min-w-20 text-center tabular-nums text-on-surface" aria-live="polite">
          {value === null ? "поровну" : value}
        </span>
        <Button
          variant="outline"
          size="icon"
          aria-label="Больше пунктов слева"
          disabled={value === SPLIT_MAX}
          onClick={() => onChange(value === null ? 3 : Math.min(SPLIT_MAX, value + 1))}
        >
          <Plus className="size-4" />
        </Button>
        {value !== null ? (
          <Button variant="ghost" onClick={() => onChange(null)}>
            Поровну
          </Button>
        ) : null}
      </div>
      <p className="type-caption text-on-surface-variant">Остальные пункты встанут справа от логотипа. Проверьте в предпросмотре.</p>
    </div>
  );
}
